module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-05-03-690_com.pinkcoffee.sexbattle.1d0a0785.jpg";